import { registerSW } from 'virtual:pwa-register'

/**
 * Enregistrement du service worker avec auto-update.
 *
 * Objectif : après chaque déploiement, le client récupère la nouvelle version
 * sans intervention manuelle, et SANS boucle de rechargement.
 *
 * Garde anti-boucle : on ne recharge qu'une seule fois par session de
 * "controllerchange". Si le serveur renvoyait en boucle un SW différent, le
 * flag sessionStorage empêche le rechargement en rafale.
 */

const RELOAD_FLAG = 'pwa:reloading'
// Intervalle de vérification d'une nouvelle version (app ouverte longtemps)
const UPDATE_INTERVAL_MS = 60 * 1000

export function registerServiceWorker() {
  if (import.meta.env.DEV) return
  if (!('serviceWorker' in navigator)) return

  // Le SW a pris le contrôle avec une nouvelle version -> on recharge une fois.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (sessionStorage.getItem(RELOAD_FLAG) === '1') return
    sessionStorage.setItem(RELOAD_FLAG, '1')
    window.location.reload()
  })

  // Une fois la page chargée sans update en attente, on libère le flag.
  window.addEventListener('load', () => {
    window.setTimeout(() => sessionStorage.removeItem(RELOAD_FLAG), 10_000)
  })

  const updateSW = registerSW({
    immediate: true,

    // Nouvelle version prête : on l'active immédiatement.
    // skipWaiting() -> controllerchange -> reload (géré ci-dessus).
    onNeedRefresh() {
      updateSW(true)
    },

    onRegisteredSW(_swUrl, registration) {
      if (!registration) return

      const checkForUpdate = () => {
        if (document.visibilityState !== 'visible') return
        if (!navigator.onLine) return
        registration.update().catch(() => {
          /* hors-ligne ou réseau instable : on réessaiera */
        })
      }

      // Vérification périodique tant que l'app reste ouverte
      window.setInterval(checkForUpdate, UPDATE_INTERVAL_MS)

      // Vérification au retour au premier plan (cas PWA installée sur mobile :
      // l'app n'est jamais "rechargée", elle est seulement mise en arrière-plan)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForUpdate()
      })

      window.addEventListener('online', checkForUpdate)
    },
  })
}
